import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Form, Button, Grid, Message } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';

// Global Actions
import { updateHarvestEventTimeline } from 'services/harvestEvents/actions';

interface Props {
    harvestEventUuid: number;
    updateHarvestEventTimeline: Function;
    handleSubmit: Function;
    onClose: Function;
    error?: string;
}

export class UnscheduleEventForm extends React.PureComponent<Props> {
    handleSubmit = (): void => {
        const { harvestEventUuid } = this.props;
        this.props.updateHarvestEventTimeline(harvestEventUuid);
        this.props.onClose();
    };

    render(): React.ReactElement {
        const { error, handleSubmit, onClose } = this.props;

        return (
            <Form onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off">
                {error && <Message negative>{error}</Message>}
                <Grid>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Button
                            type="button"
                            onClick={(): void => onClose()}
                            basic
                            primary
                            fluid
                        >
                            Cancel
                        </Button>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <SubmittingButton
                            type="submit"
                            namespace="EVENT_UNSCHEDULE"
                            negative
                            fluid
                        >
                            Confirm
                        </SubmittingButton>
                    </Grid.Column>
                </Grid>
            </Form>
        );
    }
}

export default connect(
    null,
    { updateHarvestEventTimeline }
)(
    reduxForm<any, any>({
        form: 'EVENT_UNSCHEDULE'
    })(UnscheduleEventForm)
);
